<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-15 10:30:45
 * @LastEditTime: 2022-03-25 14:55:51
 * @LastEditors: chenguobiao
-->
<template>
  <div class="button-list" v-if="showButton" v-cloak>
    <div class="registration-button" v-if="certificateQualifications" @click="handleClickRegistration">
      <div class="registration-button__bg">
        <img src="@/render/assets/images/home/registration_button.png">
      </div>
    </div>
    <div class="grading-button" @click="handleClick" v-else>
      <div class="grading-button__bg">
        <img src="@/render/assets/images/home/grading_button.png" v-if="!disabled">
        <img src="@/render/assets/images/home/disabled_grading_button.png"  v-else>
      </div>
      <div class="grading-button__text">{{buttonText}}</div>
    </div>
  </div>
</template>

<script>
import store from 'store'
import { USER_INFO } from '@/config/const'
import { debounce } from '@/render/utils'
export default {
  props: ['testQualifications', 'applyQualifications', 'certificateQualifications', 'showButton'],
  computed: {
    disabled() {
      return !(this.testQualifications || this.applyQualifications)
    },
    buttonText() {
      return this.applyQualifications ? '申请考级' : '开始考级'
    }
  },
  data() {
    return {
      loaded: false,
      userInfo: {
      }
    }
  },
  mounted() {
    this.userInfo = store.get(USER_INFO)
    this.loaded = true
  },
  methods: {
    handleClick: debounce(function() {
      this.$emit('handleClick')
    }),
    handleClickRegistration: debounce(function() {
      this.$emit('handleClickRegistration')
    })
  },
}
</script>

<style lang="scss" scoped>
  .button-list {
    display: none;
    display: flex;
    align-items: center;
    .grading-button {
      cursor: pointer;
      width: val(296);
      &__text {
        position: absolute;
        left: val(49);
        top: val(33);
        font-size: val(24);
        font-weight: 400;
        color: #FFEFDB;
      }
    }
    .registration-button {
      cursor: pointer;
      width: val(297);
    }
  }
</style>
